import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import logoImg from '../assets/blast-logo.webp';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3301/api';

export default function Home() {
  const [members, setMembers] = useState([]);
  const [events, setEvents] = useState([]);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [messagesLoading, setMessagesLoading] = useState(true);
  const [albums, setAlbums] = useState([]);
  const [albumsLoading, setAlbumsLoading] = useState(true);
  const [partners, setPartners] = useState([]);
  const [partnersLoading, setPartnersLoading] = useState(true);
  const [content, setContent] = useState({});

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  };
  const loggedInName = getCookie('blast_logged_in_name');
  const memberToken = getCookie('blast_member_token');
  const [newMessage, setNewMessage] = useState('');
  const [posting, setPosting] = useState(false);

  const handlePostMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim() || !memberToken) return;
    setPosting(true);
    try {
      await axios.post(`${API_BASE}/messages/`, { message: newMessage.trim() }, {
        headers: { Authorization: `Bearer ${memberToken}` },
      });
      setNewMessage('');
      const res = await axios.get(`${API_BASE}/messages/`);
      setMessages(res.data);
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal mengirim pesan');
    } finally {
      setPosting(false);
    }
  };

  useEffect(() => {
    Promise.all([
      axios.get(`${API_BASE}/member-auth/public`),
      axios.get(`${API_BASE}/touring-events/`),
    ])
      .then(([memberRes, eventRes]) => {
        setMembers(memberRes.data);
        setEvents(eventRes.data);
      })
      .catch((err) => console.error('Fetch home data error:', err))
      .finally(() => setLoading(false));

    axios.get(`${API_BASE}/messages/`)
      .then((res) => setMessages(res.data))
      .catch((err) => console.error('Fetch messages error:', err))
      .finally(() => setMessagesLoading(false));

    axios.get(`${API_BASE}/gallery/`)
      .then((res) => setAlbums(res.data))
      .catch((err) => console.error('Fetch gallery error:', err))
      .finally(() => setAlbumsLoading(false));

    axios.get(`${API_BASE}/partners/`)
      .then((res) => setPartners(res.data))
      .catch((err) => console.error('Fetch partners error:', err))
      .finally(() => setPartnersLoading(false));

    axios.get(`${API_BASE}/site-content/`)
      .then((res) => setContent(res.data))
      .catch((err) => console.error('Fetch site content error:', err));
  }, []);

  const activeEvents = events
    .filter((e) => e.status === 'upcoming' || e.status === 'ongoing')
    .sort((a, b) => (a.status === 'ongoing' ? -1 : 1) - (b.status === 'ongoing' ? -1 : 1));

  return (
    <div style={{ background: '#12151A', color: '#F0EDE4', fontFamily: "'Segoe UI', sans-serif", overflowX: 'hidden' }}>
      <style>{`
        @keyframes routeDash {
          to { stroke-dashoffset: 0; }
        }
        .blast-route-line {
          stroke-dasharray: 12 8;
          stroke-dashoffset: 2000;
          animation: routeDash 3s linear forwards;
        }
        .blast-member-card:nth-child(odd) {
          transform: translateY(-14px) rotate(-1.2deg);
        }
        .blast-member-card:nth-child(even) {
          transform: translateY(10px) rotate(1deg);
        }
        .blast-member-card:hover {
          transform: translateY(-6px) rotate(0deg) scale(1.03) !important;
          transition: transform 0.25s ease;
        }
      `}</style>

      {/* NAV */}
      <nav style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '18px 6vw', position: 'relative', zIndex: 10,
      }}>
        <img src={logoImg} alt="Blast Motor Club" style={{ height: 40, width: 'auto' }} />
        <div style={{ display: 'flex', gap: 28, fontSize: 13, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase' }}>
          <a href="#roster" style={{ color: '#F0EDE4', textDecoration: 'none' }}>Member</a>
          <a href="#event" style={{ color: '#F0EDE4', textDecoration: 'none' }}>Event</a>
          <a href="#galeri" style={{ color: '#F0EDE4', textDecoration: 'none' }}>Galeri</a>
        </div>
        <a href={loggedInName ? "https://member.ridewithblast.com/dashboard" : "https://member.ridewithblast.com/login"} style={{
          background: '#D02127', color: '#fff', border: 'none', padding: '10px 22px',
          fontWeight: 800, fontSize: 13, letterSpacing: 1, textTransform: 'uppercase',
          clipPath: 'polygon(8% 0, 100% 0, 92% 100%, 0 100%)', cursor: 'pointer',
          textDecoration: 'none', display: 'inline-block',
        }}>
          {loggedInName ? loggedInName : 'Masuk'}
        </a>
      </nav>

      {/* HERO - diagonal clip */}
      <section style={{
        position: 'relative',
        padding: '60px 6vw 140px',
        clipPath: 'polygon(0 0, 100% 0, 100% 88%, 0 100%)',
        background: 'linear-gradient(160deg, #171b21 0%, #0f1116 60%, #12151A 100%)',
        overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', top: '10%', right: '-8%', width: 500, height: 500,
          background: 'radial-gradient(circle, rgba(208,33,39,0.15) 0%, transparent 70%)',
        }} />
        <span style={{
          color: '#D02127', fontWeight: 800, fontSize: 13, letterSpacing: 4, textTransform: 'uppercase',
        }}>
          {content.hero_eyebrow || 'Komunitas Motor'}
        </span>
        <h1 style={{
          fontSize: 'clamp(48px, 8vw, 96px)', fontWeight: 900, fontStyle: 'italic',
          lineHeight: 1.02, margin: '10px 0 20px', maxWidth: 720,
        }}>
          {content.hero_title_line1 || 'BLAST'}<br />{content.hero_title_line2 || 'MOTOR CLUB'}
        </h1>
        <p style={{ color: '#8B92A0', fontSize: 16, maxWidth: 460, lineHeight: 1.6 }}>
          {content.hero_subtitle || 'Solid di jalan, satu di semangat. Touring bareng, dukung sesama, jaga persaudaraan.'}
        </p>
        <div style={{ display: 'flex', gap: 16, marginTop: 32 }}>
          <a href="https://member.ridewithblast.com/register" style={{
            background: '#2B6996', color: '#fff', border: 'none', padding: '14px 30px',
            fontWeight: 800, fontSize: 14, letterSpacing: 1, textTransform: 'uppercase',
            clipPath: 'polygon(6% 0, 100% 0, 94% 100%, 0 100%)', cursor: 'pointer',
            textDecoration: 'none', display: 'inline-block',
          }}>
            {content.hero_cta_text || 'Gabung Sekarang'}
          </a>
        </div>
      </section>

      {/* ROSTER */}
      <section id="roster" style={{ padding: '20px 6vw 80px', position: 'relative' }}>
        <span style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 3, textTransform: 'uppercase' }}>
          {content.roster_eyebrow || 'Roster'}
        </span>
        <h2 style={{ fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 40px' }}>
          {content.roster_title || 'Member Kami'}
        </h2>
        {loading ? (
          <p style={{ color: '#8B92A0' }}>Memuat data member...</p>
        ) : members.length === 0 ? (
          <p style={{ color: '#8B92A0' }}>Belum ada member yang tampil di sini.</p>
        ) : (
          <>
            <div style={{
              display: 'flex', overflowX: 'auto', gap: 0, paddingTop: 10, paddingBottom: 10,
              WebkitOverflowScrolling: 'touch',
            }}>
              {members.slice(0, 7).map((m, i) => (
                <Link
                  key={m.id}
                  to={`/members/${m.slug}`}
                  style={{
                    background: '#1C2128', border: '1px solid #262b33', flexShrink: 0,
                    width: 130, aspectRatio: '3/4', borderRadius: 12, overflow: 'hidden',
                    textDecoration: 'none', color: 'inherit', display: 'block', position: 'relative',
                    marginLeft: i === 0 ? 0 : -28,
                    transform: `rotate(${i % 2 === 0 ? -3 : 3}deg)`,
                    boxShadow: '0 4px 14px rgba(0,0,0,0.4)',
                    zIndex: i,
                  }}
                >
                  <div style={{ width: '100%', height: '100%', background: '#262b33' }}>
                    {m.photo_url ? (
                      <img src={m.photo_url} alt={m.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4a5160', fontSize: 11 }}>
                        Foto
                      </div>
                    )}
                  </div>
                  <div style={{
                    position: 'absolute', bottom: 0, left: 0, right: 0, padding: '20px 10px 10px',
                    background: 'linear-gradient(to top, rgba(0,0,0,0.9), transparent)',
                  }}>
                    <p style={{ fontWeight: 800, fontSize: 13, color: '#fff', lineHeight: 1.2 }}>{m.name}</p>
                    <p style={{ color: '#D02127', fontSize: 9, fontWeight: 700, letterSpacing: 0.3, textTransform: 'uppercase', marginTop: 2 }}>{m.position}</p>
                  </div>
                </Link>
              ))}
            </div>
            <div style={{ marginTop: 24 }}>
              <Link to="/members" style={{ color: '#2B6996', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
                Lihat Member Lainnya →
              </Link>
            </div>
          </>
        )}
      </section>

      {/* SAFETY RIDING BANNER */}
      <section style={{ padding: '0 6vw' }}>
        <Link to="/safety-riding" style={{
          display: 'flex', alignItems: 'center', gap: 20, textDecoration: 'none', color: 'inherit',
          background: 'linear-gradient(120deg, rgba(208,33,39,0.15) 0%, rgba(43,105,150,0.1) 100%)',
          border: '1px solid #262b33', borderRadius: 14, padding: '22px 24px', flexWrap: 'wrap',
        }}>
          <div style={{
            width: 52, height: 52, borderRadius: '50%', background: 'rgba(208,33,39,0.2)', flexShrink: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, color: '#D02127',
          }}>
            <i className="fa-solid fa-helmet-safety"></i>
          </div>
          <div style={{ flex: 1, minWidth: 200 }}>
            <p style={{ fontWeight: 800, fontSize: 16 }}>Sebelum Touring, Baca Ini Dulu 🏍️</p>
            <p style={{ color: '#8B92A0', fontSize: 13, marginTop: 2 }}>Panduan Safety Riding — kelengkapan, cek motor, sampai etika touring bareng.</p>
          </div>
          <span style={{
            background: '#D02127', color: '#fff', padding: '10px 20px', borderRadius: 8,
            fontWeight: 700, fontSize: 13, whiteSpace: 'nowrap',
          }}>
            Baca Sekarang →
          </span>
        </Link>
      </section>

      {/* CHECKERED STRIP DIVIDER */}
      <div style={{
        height: 22, backgroundImage: 'repeating-linear-gradient(90deg, #F0EDE4 0px, #F0EDE4 18px, #12151A 18px, #12151A 36px)',
        transform: 'skewY(-1.5deg)', margin: '20px 0',
      }} />

      {/* EVENT */}
      <section id="event" style={{ padding: '60px 6vw 80px' }}>
        <span style={{ color: '#2B6996', fontWeight: 800, fontSize: 12, letterSpacing: 3, textTransform: 'uppercase' }}>
          {content.event_eyebrow || 'Touring'}
        </span>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap', gap: 10, marginBottom: 24 }}>
          <h2 style={{ fontSize: 'clamp(24px, 3.5vw, 36px)', fontWeight: 900, fontStyle: 'italic', margin: 0 }}>
            {content.event_title || 'Lagi Jalan & Akan Datang'}
          </h2>
          <Link to="/history" style={{ color: '#2B6996', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
            Lihat Semua Touring →
          </Link>
        </div>
        {activeEvents.length === 0 ? (
          <p style={{ color: '#8B92A0', fontSize: 14 }}>Belum ada touring yang berlangsung atau akan datang saat ini.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {activeEvents.map((ev) => (
              <div key={ev.id} style={{
                background: 'linear-gradient(120deg, #1C2128 0%, #171b21 100%)', padding: 24, clipPath: 'polygon(0 0, 96% 0, 100% 100%, 4% 100%)',
                border: '1px solid #262b33', maxWidth: 520,
              }}>
                <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
                  {ev.status === 'ongoing' && (
                    <span style={{ background: 'rgba(208,33,39,0.2)', color: '#D02127', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 4, textTransform: 'uppercase' }}>
                      🔴 Live
                    </span>
                  )}
                  <span style={{
                    background: ev.tipe === 'santai' ? 'rgba(139,146,160,0.2)' : 'rgba(43,105,150,0.2)',
                    color: ev.tipe === 'santai' ? '#8B92A0' : '#2B6996',
                    fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 4, textTransform: 'uppercase',
                  }}>
                    {ev.tipe === 'santai' ? 'Touring Santai' : 'Touring Resmi'}
                  </span>
                </div>
                <p style={{ fontWeight: 800, fontSize: 18, marginBottom: 10 }}>{ev.title}</p>
                {ev.location && <p style={{ color: '#8B92A0', fontSize: 14, marginBottom: 6 }}>📍 {ev.location}</p>}
                <p style={{ color: '#8B92A0', fontSize: 14, marginBottom: ev.status === 'ongoing' ? 14 : 0 }}>
                  📅 {new Date(ev.tanggal_mulai).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}
                </p>
                {ev.status === 'ongoing' && (
                  <Link to={`/live-touring/${ev.id}`} style={{
                    display: 'inline-block', background: '#D02127', color: '#fff', textDecoration: 'none',
                    padding: '8px 18px', borderRadius: 6, fontSize: 12, fontWeight: 700,
                  }}>
                    Lihat Live →
                  </Link>
                )}
              </div>
            ))}
          </div>
        )}
      </section>

      {/* GALERI */}
      <section id="galeri" style={{ padding: '20px 6vw 60px' }}>
        <span style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 3, textTransform: 'uppercase' }}>
          {content.galeri_eyebrow || 'Galeri'}
        </span>
        <h2 style={{ fontSize: 'clamp(24px, 3.5vw, 36px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 24px' }}>
          {content.galeri_title || 'Dokumentasi Touring'}
        </h2>
        {albumsLoading ? (
          <p style={{ color: '#8B92A0', fontSize: 13 }}>Memuat galeri...</p>
        ) : albums.length === 0 ? (
          <p style={{ color: '#8B92A0', fontSize: 13 }}>Belum ada galeri. Album otomatis muncul setelah event touring selesai.</p>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16 }}>
              {albums.slice(0, 6).map((a) => (
                <Link
                  key={a.id}
                  to={`/gallery/${a.id}`}
                  style={{
                    background: '#1C2128', border: '1px solid #262b33', padding: 16,
                    textDecoration: 'none', color: 'inherit', display: 'block',
                    clipPath: 'polygon(0 0, 100% 0, 100% 90%, 90% 100%, 0 100%)',
                  }}
                >
                  <p style={{ fontWeight: 800, fontSize: 14 }}>{a.event_title}</p>
                  <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 4 }}>
                    {new Date(a.tanggal_mulai).toLocaleDateString('id-ID')}
                  </p>
                  <p style={{ color: '#2B6996', fontSize: 12, marginTop: 8, fontWeight: 700 }}>
                    📷 {a.total_foto} foto
                  </p>
                </Link>
              ))}
            </div>
            <div style={{ marginTop: 20 }}>
              <Link to="/gallery" style={{ color: '#2B6996', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
                Lihat Galeri Lainnya →
              </Link>
            </div>
          </>
        )}
      </section>

      {/* MESSAGE BOARD */}
      <section id="message-board" style={{ padding: '20px 6vw 60px' }}>
        <span style={{ color: '#2B6996', fontWeight: 800, fontSize: 12, letterSpacing: 3, textTransform: 'uppercase' }}>
          {content.message_eyebrow || 'Papan Pesan'}
        </span>
        <h2 style={{ fontSize: 'clamp(24px, 3.5vw, 36px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 24px' }}>
          {content.message_title || 'Obrolan Member'}
        </h2>
        {messagesLoading ? (
          <p style={{ color: '#8B92A0', fontSize: 13 }}>Memuat pesan...</p>
        ) : messages.length === 0 ? (
          <p style={{ color: '#8B92A0', fontSize: 13 }}>Belum ada pesan. Jadi yang pertama nulis!</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxHeight: 400, overflowY: 'auto' }}>
            {messages.map((m) => (
              <div key={m.id} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 14 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap', gap: 6 }}>
                  <span style={{ fontWeight: 700, fontSize: 13 }}>{m.member_name}</span>
                  <span style={{ color: '#D02127', fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>{m.member_position}</span>
                </div>
                <p style={{ fontSize: 13, marginTop: 6, color: '#c8ccd3' }}>{m.message}</p>
                <p style={{ color: '#5a616e', fontSize: 10, marginTop: 6 }}>{new Date(m.created_at).toLocaleString('id-ID')}</p>
              </div>
            ))}
          </div>
        )}
        {memberToken ? (
          <form onSubmit={handlePostMessage} style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <input
              type="text"
              placeholder="Tulis pesan..."
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              style={{ flex: 1, background: '#1C2128', border: '1px solid #262b33', borderRadius: 6, padding: '10px 14px', color: '#F0EDE4', fontSize: 14 }}
            />
            <button
              type="submit"
              disabled={posting}
              style={{ background: '#D02127', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: 6, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}
            >
              {posting ? '...' : 'Kirim'}
            </button>
          </form>
        ) : (
          <p style={{ color: '#5a616e', fontSize: 12, marginTop: 16 }}>
            Mau nulis pesan? <a href="https://member.ridewithblast.com/login" style={{ color: '#2B6996' }}>Login sebagai member</a> dulu.
          </p>
        )}
      </section>

      {/* OUR PARTNERS */}
      {!partnersLoading && partners.length > 0 && (
        <section id="partners" style={{ padding: '20px 6vw 60px' }}>
          <span style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 3, textTransform: 'uppercase' }}>
            {content.partners_eyebrow || 'Sponsor'}
          </span>
          <h2 style={{ fontSize: 'clamp(24px, 3.5vw, 36px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 32px' }}>
            {content.partners_title || 'Our Partners'}
          </h2>
          <div style={{
            display: 'flex', flexWrap: 'wrap', gap: 28, alignItems: 'center', justifyContent: 'flex-start',
          }}>
            {partners.map((p) => {
              const logo = (
                <img
                  src={p.logo_url}
                  alt={p.name}
                  title={p.name}
                  style={{ height: 56, width: 'auto', maxWidth: 160, objectFit: 'contain', filter: 'grayscale(20%)', opacity: 0.9 }}
                />
              );
              return p.website_url ? (
                <a key={p.id} href={p.website_url} target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
                  {logo}
                </a>
              ) : (
                <div key={p.id}>{logo}</div>
              );
            })}
          </div>
        </section>
      )}

      <footer style={{ padding: '32px 6vw', borderTop: '1px solid #262b33', textAlign: 'center', color: '#5a616e', fontSize: 12 }}>
        {content.footer_text || '© 2026 Blast Motor Club'} · <Link to="/safety-riding" style={{ color: '#5a616e' }}>Safety Riding</Link> · <Link to="/privacy" style={{ color: '#5a616e' }}>Kebijakan Privasi & Syarat Ketentuan</Link>
      </footer>
    </div>
  );
}
